<script>
import Multiselect from 'vue-multiselect'
import UploadFile from '@components/upload-file'
import DictionariesTable from '@components/dictionaries-table'

export default {

    components: { Multiselect, UploadFile, DictionariesTable },

    props: {

    },

    data() {
        return {
            trackBy: 'code',
            words_equal: [],
            words_equal_options: [],
            words_in: [],
            words_in_options: [],
            words_not_in: [],
            words_not_in_options: [],
            saveModal: false,
            loadModal: false,
            dictionary_name: null,
            dictionary_description: null,
            success_save_modal_text: null,
            success_save_modal: false
        }
    },

    watch: {
        words_equal: {
            immediate: true,
            handler(values) {
                let words_equal_save = [];
                this.words_equal.forEach(el => {
                    words_equal_save.push(el.name);
                });
                this.$parent.intent.words_equal = words_equal_save;
            }
        },
        words_in: {
            immediate: true,
            handler(values) {
                let words_in_save = [];
                this.words_in.forEach(el => {
                    words_in_save.push(el.name);
                });
                this.$parent.intent.words_in = words_in_save;
            }
        },
        words_not_in: {
            immediate: true,
            handler(values) {
                let words_not_in_save = [];
                this.words_not_in.forEach(el => {
                    words_not_in_save.push(el.name);
                });
                this.$parent.intent.words_not_in = words_not_in_save;
            }
        },
    },

    computed: {
        dictionary_item(){
            return this.$store.getters['dictionaries/GET_DICTIONARIES_ITEM'];
        },
    },

    async mounted() {

      let words_equal_list = []
      let words_in_list = []
      let words_not_in_list = []

      if (this.$parent.params) {
        words_equal_list = this.$parent.params.intent.words_equal ? this.$parent.params.intent.words_equal : [];
        words_in_list = this.$parent.params.intent.words_in ? this.$parent.params.intent.words_in : [];
        words_not_in_list = this.$parent.params.intent.words_not_in ? this.$parent.params.intent.words_not_in : [];
      }

        let words_equal = [];
        let words_in = [];
        let words_not_in = [];

        words_equal_list.forEach(el => {
            words_equal.push({ name: el, code: el });
        });

        words_in_list.forEach(el => {
            words_in.push({ name: el, code: el });
        });

        words_not_in_list.forEach(el => {
            words_not_in.push({ name: el, code: el });
        });

        this.words_equal = words_equal;
        this.words_equal_options = words_equal;

        this.words_in = words_in;
        this.words_in_options = words_in;

        this.words_not_in = words_not_in;
        this.words_not_in_options = words_not_in;
    },

    methods: {
        addWordsEqual (newTag) {

            newTag =  String(newTag)
            if(newTag.indexOf(';') === -1){
                const tag = {
                    name: newTag.trim(),
                    code: newTag.trim()
                }
                this.words_equal.push(tag);
            } else {
                let arr = newTag.split(';');
                arr.forEach(el => {
                    el = String(el);
                    this.words_equal.push({
                        name: el.trim(),
                        code: el.trim(),
                    });
                })
            }

            this.words_equal_options = this.words_equal;
        },
        addWordsIn (newTag) {
            newTag =  String(newTag)
            if(newTag.indexOf(';') === -1){
                const tag = {
                    name: newTag.trim(),
                    code: newTag.trim(),
                }
                this.words_in.push(tag);
            } else {
                let arr = newTag.split(';');
                arr.forEach(el => {
                    el = String(el);
                    this.words_in.push({
                        name: el.trim(),
                        code: el.trim(),
                    });
                })
            }
            this.words_in_options = this.words_in;
        },
        addWordsNotIn (newTag) {
            newTag =  String(newTag)
            if(newTag.indexOf(';') === -1){
                const tag = {
                    name: newTag.trim(),
                    code: newTag.trim(),
                }
                this.words_not_in.push(tag);
            } else {
                let arr = newTag.split(';');
                arr.forEach(el => {
                    el = String(el);
                    this.words_not_in.push({
                        name: el.trim(),
                        code: el.trim(),
                    });
                })
            }
            this.words_not_in_options = this.words_not_in;
        },
        async saveDictionary(){

            let words_equal_save = [];
            let words_in_save = [];
            let words_not_in_save = [];

            this.words_equal.forEach(el => {
                words_equal_save.push(el.name);
            });

            this.words_in.forEach(el => {
                words_in_save.push(el.name);
            });

            this.words_not_in.forEach(el => {
                words_not_in_save.push(el.name);
            });

            let data_send = {
                'name'         : this.dictionary_name,
                'description'  : this.dictionary_description,
                'words_equal'  : JSON.stringify(words_equal_save),
                'words_in'     : JSON.stringify(words_in_save),
                'words_not_in' : JSON.stringify(words_not_in_save),
            };

            let result = '';

            result = await this.$store.dispatch('dictionaries/FETCH_DICTIONARIES_CREATE', data_send);

            if(result === false){
                alert('Возникла ошибка');
            } else {
                this.saveModal = false;
                this.success_save_modal = true;
            }
        },
        async loadDictionary(uuid){

            let data_send = {
                'uuid' : uuid,
            }
            await this.$store.dispatch('dictionaries/FETCH_DICTIONARIES_ITEM', data_send);

            this.name = this.dictionary_item.name ? this.dictionary_item.name : '';
            this.description = this.dictionary_item.description ? this.dictionary_item.description : '';

            let words_equal_list = this.dictionary_item.words_equal ? JSON.parse(this.dictionary_item.words_equal) : [];
            let words_in_list = this.dictionary_item.words_in ? JSON.parse(this.dictionary_item.words_in) : [];
            let words_not_in_list = this.dictionary_item.words_not_in ? JSON.parse(this.dictionary_item.words_not_in) : [];

            let words_equal = [];
            let words_in = [];
            let words_not_in = [];

            words_equal_list.forEach(el => {
                words_equal.push({ name: el, code: el });
            });

            words_in_list.forEach(el => {
                words_in.push({ name: el, code: el });
            });

            words_not_in_list.forEach(el => {
                words_not_in.push({ name: el, code: el });
            });

            this.words_equal = words_equal;
            this.words_equal_options = words_equal;

            this.words_in = words_in;
            this.words_in_options = words_in;

            this.words_not_in = words_not_in;
            this.words_not_in_options = words_not_in;

            this.loadModal = false;

            return false;
        },
        async clear(type){
            if(type === 'words_equal'){
                this.words_equal = [];
                this.words_equal_options = [];
            }
            if(type === 'words_in'){
                this.words_in = [];
                this.words_in_options = [];
            }
            if(type === 'words_not_in'){
                this.words_not_in = [];
                this.words_not_in_options = [];
            }
        }
    }
}
</script>

<template>
    <div>

        <b-form-group
            label="Переменная для сравнения"
            label-for="intent_action"
        >
            <b-form-input
                id="intent_action"
                v-model="$parent.intent.variable"
                placeholder="Укажите название переменной"
            ></b-form-input>
        </b-form-group>

        <div class="row" style="margin-top: 50px !important; margin-bottom: 30px !important;">
            <div class="col-sm-12 col-xl-7">
                <h4 class="mb-3 mt-0 header-title" style="margin-top: 20px !important; margin-bottom: 0px !important; font-size: 16px"><i class="feather uil uil-book-alt"></i>Тренировочные фразы:</h4>
            </div>
            <div class="col-sm-12 col-xl-5">
                <a href="#" @click.prevent="saveModal = true" id="saveModal" class="btn btn-outline-secondary float-sm-right" style="margin-left: 7px; margin-top: 10px">
                    <b-tooltip target="saveModal" placement="top">Сохранить в словарь</b-tooltip>
                    <i class="uil uil-file-check-alt"></i>
                </a>
                <a href="#" @click.prevent="loadModal = true" id="loadModal" class="btn btn-outline-secondary float-sm-right" style="margin-top: 10px; margin-left: 7px; margin-right: 0px">
                    <b-tooltip target="loadModal" placement="top">Загрузить из словаря</b-tooltip>
                    <i class="uil uil-file-download-alt"></i>
                </a>
            </div>
        </div>


        <div class="row mb-1">
            <div class="col-sm-12 col-xl-7">
                <p style="margin-top: 20px !important; margin-bottom: 0px !important; font-size: 0.875rem;; font-weight: 600">Фраза полностью совпадает</p>
            </div>
            <div class="col-sm-12 col-xl-5">
                <a href="#" @click.prevent="clear('words_equal')" id="clear_words_equal" class="btn btn-outline-secondary float-sm-right" style="margin-top: 10px; margin-left: 7px; margin-right: 0px">
                    <b-tooltip target="clear_words_equal" placement="top">Очистить</b-tooltip>
                    <i class="uil uil-trash"></i>
                </a>
            </div>
        </div>
        <b-form-group>
            <multiselect
                id="words_equal"
                :track-by="trackBy"
                v-model="words_equal"
                :options="words_equal_options"
                :multiple="true"
                :taggable="true"
                @tag="addWordsEqual"
                placeholder=""
                selectLabel="Нажмите, чтобы выбрать"
                deselectLabel="Нажмите, снять выделение"
                label="name"
            ></multiselect>
        </b-form-group>


        <div class="row mb-1">
            <div class="col-sm-12 col-xl-7">
                <p style="margin-top: 20px !important; margin-bottom: 0px !important; font-size: 0.875rem;; font-weight: 600">Фраза содержит</p>
            </div>
            <div class="col-sm-12 col-xl-5">
                <a href="#" @click.prevent="clear('words_in')" id="clear_words_equal" class="btn btn-outline-secondary float-sm-right" style="margin-top: 10px; margin-left: 7px; margin-right: 0px">
                    <b-tooltip target="clear_words_equal" placement="top">Очистить</b-tooltip>
                    <i class="uil uil-trash"></i>
                </a>
            </div>
        </div>
        <b-form-group>
            <multiselect
                id="words_in"
                :track-by="trackBy"
                v-model="words_in"
                :options="words_in_options"
                :multiple="true"
                :taggable="true"
                @tag="addWordsIn"
                placeholder=""
                selectLabel="Нажмите, чтобы выбрать"
                deselectLabel="Нажмите, снять выделение"
                label="name"
            ></multiselect>
        </b-form-group>


        <div class="row mb-1">
            <div class="col-sm-12 col-xl-7">
                <p style="margin-top: 20px !important; margin-bottom: 0px !important; font-size: 0.875rem;; font-weight: 600">Слова исключение</p>
            </div>
            <div class="col-sm-12 col-xl-5">
                <a href="#" @click.prevent="clear('words_not_in')" id="clear_words_equal" class="btn btn-outline-secondary float-sm-right" style="margin-top: 10px; margin-left: 7px; margin-right: 0px">
                    <b-tooltip target="clear_words_equal" placement="top">Очистить</b-tooltip>
                    <i class="uil uil-trash"></i>
                </a>
            </div>
        </div>
        <b-form-group>
            <multiselect
                id="words_not_in"
                :track-by="trackBy"
                v-model="words_not_in"
                :options="words_not_in_options"
                :multiple="true"
                :taggable="true"
                @tag="addWordsNotIn"
                placeholder=""
                selectLabel="Нажмите, чтобы выбрать"
                deselectLabel="Нажмите, снять выделение"
                label="name"
            ></multiselect>
        </b-form-group>
        <br>
<!--        <b-form-group-->
<!--            label="Перейти к блоку, в случае успеха"-->
<!--            label-for="intent_action"-->
<!--        >-->
<!--            <b-form-input-->
<!--                id="intent_action"-->
<!--                v-model="$parent.intent.action"-->
<!--                placeholder="Укажите ID блока или оставьте пустым"-->
<!--            ></b-form-input>-->
<!--        </b-form-group>-->

        <b-modal
            v-model="saveModal"
            centered
            size="lg"
            title="Новый словарь"
            title-class="font-18"
        >
            <b-form-group
                label="Название словаря"
                label-for="dictionary_name"
            >
                <b-form-input
                    id="dictionary_name"
                    v-model="dictionary_name"
                    placeholder="Укажите название нового словаря"
                ></b-form-input>
            </b-form-group>

            <b-form-group
                label="Комментарий к словарю"
                label-for="dictionary_description"
            >
                <b-form-input
                    id="dictionary_description"
                    v-model="dictionary_description"
                    placeholder=""
                ></b-form-input>
            </b-form-group>

            <template v-slot:modal-footer style="justify-content: flex-start !important">
                <div style="width: 100%">
                    <b-button variant="primary" class="btn-rounded" @click="saveDictionary" style="margin-right: 10px">Сохранить</b-button>
                    <b-button variant="light" class="btn-rounded" @click="saveModal = false"
                    >Отменить</b-button
                    >
                </div>
            </template>
        </b-modal>

        <b-modal
            v-model="loadModal"
            scrollable
            size="lg"
            title="Словари"
            title-class="font-18"
            hide-footer
        >
            <DictionariesTable v-bind:is_popup="true" />
        </b-modal>

        <b-modal
            v-model="success_save_modal"
            centered
            hide-footer
            title="Успешно"
            title-class="font-18"
        >
            <div class="text-center">
                <i class="uil-book-alt text-success display-3" style="margin-bottom: 15px"></i>
                <h4 class="mt-4" style="margin-bottom: 15px">Словарь успешно сохранен</h4>
                <p class="w-75 mx-auto text-muted">{{success_save_modal_text}}</p>
                <div class="mt-4">
                    <button
                        class="btn btn-outline-primary width-md"
                        style="margin-top: 15px"
                        @click="success_save_modal = false"
                    >
                        <i class="uil uil-arrow-left mr-1"></i> Вернуться
                    </button>
                </div>
            </div>
        </b-modal>

    </div>
</template>
